/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const facebookLinkSelector = document.querySelector(".footer__social-link--facebook")?.attributes.href.textContent;
    const instagramLinkSelector = document.querySelector(".footer__social-link--instagram")?.attributes.href.textContent;
    const tiktokLinkSelector = document.querySelector(".footer__social-link--tiktok")?.attributes.href.textContent;
    const youtubeLinkSelector = document.querySelector(".footer__social-link--youtube")?.attributes.href.textContent;

       // Build the social links only if valid URLs exist
       const socialLinks = [];

       if (facebookLinkSelector) {
           socialLinks.push(`<a class='fa footer__social-link--facebook' href='${facebookLinkSelector}'></a>`);
       }
   
       if (instagramLinkSelector) {
           socialLinks.push(`<a class='fa footer__social-link--instagram' href='${instagramLinkSelector}'></a>`);
       }
   
       if (tiktokLinkSelector) {
           socialLinks.push(`<a class='fa footer__social-link--tiktok' href='${tiktokLinkSelector}'></a>`);
       }
   
       if (youtubeLinkSelector) {
           socialLinks.push(`<a class='fa footer__social-link--youtube' href='${youtubeLinkSelector}'></a>`);
       }

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            slidingSubmenus: false,
            offCanvas: {
                use: true,
                position: "right"
            },
            navbars: [
                {
                    position: "bottom",
                    content: socialLinks
                }
            ]
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpoint
        var mediaQuery = window.matchMedia("(min-width: 768px)");
        mediaQuery.addEventListener("change", function () {
            if (mmenuApi) {
                mmenuApi.close();
            }
        });
    };

    init();
}
